<template>
  <div>
    <representative-table
        ref="table"
        :url="indexUrl"
        :can-create="canCreate"
        :create-url="createUrl"
    ></representative-table>
    <dialog-form-wrapper></dialog-form-wrapper>
  </div>
</template>

<script>
import DialogFormWrapper from '../dialog-form-wrapper';
import RepresentativeTable from './table';

export default {
  components: {
    DialogFormWrapper,
    RepresentativeTable,
  },

  props: {
    indexUrl: null,
    createUrl: null,
    canCreate: {
      type: Boolean,
      default: false
    },
  },
}
</script>
